import React, { Component, PropTypes } from 'react';
import TextInput from '../../../components/inputs/TextInput';
import DateRangeSelector from '../../../components/DateRangeSelector';
import { CompactPicker } from 'react-color';
import RequiredIndicator from '../../../components/layout/RequiredIndicator';

const REQUIRED = <RequiredIndicator className="md-font"/>;

const TourneyForm = ({ additionalFields: AdditionalFields, onChange, value }) => {
  const {
    name,
    start,
    end,
    color,
    acronym,
    link,
    location: { address: { city, province } = {} } = {},
    session: { start: sessionStart, end: sessionEnd } = {}
  } = value;

  const change = more => onChange({ ...value, ...more });
  const locationChange = location => change({ location });
  const addressChange = more => locationChange({ address: { city, province, ...more } });

  return (
    <div>
      <div className="display-flex">
        <div className="flex-grow-4">
          <label>Name {REQUIRED}</label>
          <TextInput onChange={(e) => change({ name: e.target.value })} placeholder="Tourney Name" value={name}/>
        </div>
        <div className="flex-grow-1 mg-left-sm">
          <label>Acronym {REQUIRED}</label>
          <TextInput
            onChange={(e) => change({ acronym: e.target.value })} placeholder="Acronym" value={acronym}
            maxLength={5}
          />
        </div>
      </div>

      <div className="display-flex full-width mg-top-md">
        <div className="flex-grow-1">
          <label>City {REQUIRED}</label>
          <TextInput onChange={e => addressChange({ city: e.target.value })} placeholder="City" value={city}/>
        </div>

        <div className="flex-grow-1 mg-left-sm">
          <label>State / Province {REQUIRED}</label>
          <TextInput
            onChange={e => addressChange({ province: e.target.value })} placeholder="State / Province"
            value={province}
          />
        </div>
      </div>

      <div className="display-flex mg-top-md">
        <label className="display-flex flex-grow-1">Tourney Start Date {REQUIRED}</label>
        <label className="display-flex flex-grow-1 mg-left-sm">Tourney End Date {REQUIRED}</label>
      </div>

      <DateRangeSelector
        className="display-flex flex-direction-row full-width mg-top-xs"
        dateSelectorClassName="half-width" minValue={start} maxValue={end}
        minOption={sessionStart} maxOption={sessionEnd}
        onChange={({ min: start, max: end }) => change({ start, end })}
        onWarning={() => null}
      />

      <div className="display-flex mg-top-md">
        <div className="display-inline-block">
          <label>Color {REQUIRED}</label>
          <CompactPicker color={color} onChange={({ hex }) => change({ color: hex.substr(1) })}/>
        </div>

        <div className="mg-left-sm flex-grow-1">
          <label>Url</label>
          <TextInput
            onChange={e => change({ link: e.target.value })}
            placeholder="https://www.my-tourney.com"
            value={link}
          />
        </div>
      </div>

      {AdditionalFields &&
        <AdditionalFields value={value} onChange={onChange}/>
      }
    </div>
  );
};

export default TourneyForm;


// WEBPACK FOOTER //
// ./src/js/common/components/forms/TourneyForm.jsx